module.exports = __webpack_public_path__ + "img/union-berlin-logo-icon.ed57494c.png";